import { Printer } from '@/features/print/types'
import { FormKeys as EditFormKeys } from '@/features/settings/components/PrinterConfiguration/form/constants'
import { Form as EditForm } from '@/features/settings/components/PrinterConfiguration/form/types'
import { AddPrinterData } from '@/features/settings/contexts/AddPrinter'
import { createConnectionOptionsFromAddData } from '@/features/settings/pages/NewPrinterPage/utils/createConnectionOptionsFromAddData'
import uuid from 'react-native-uuid'

export const createPrinter = async (
    addPrinterData: AddPrinterData,
    editForm: EditForm
): Promise<Printer> => {
    return {
        id: uuid.v4(),
        name: editForm[EditFormKeys.Name],
        printTypes: editForm[EditFormKeys.PrintTypes],
        charsPerLine: parseInt(editForm[EditFormKeys.CharsPerLine]),
        paperWidth: parseInt(editForm[EditFormKeys.PaperWidth]),
        connectionOptions: createConnectionOptionsFromAddData(addPrinterData),
    }
}
